import { createContext } from 'react'

export type OnboardingFlowType = 'new-account' | 'invite'

export interface OnboardingFlowContextType {
    flowType: OnboardingFlowType
}

export const OnboardingFlowContext = createContext<OnboardingFlowContextType | null>(null)
